import samplePdf from "./handbook.pdf";
import { FcRules } from "react-icons/fc";

import { Button } from "@/components/ui/button/button";

export const HandbookRender = () => {
  return (
    <>
      <Button size="sm" asChild variant="outline" className="self-start h-9">
        <a href={samplePdf} target="_blank" className="flex items-center gap-3">
          <FcRules className="w-5 h-5" />
          Rules & Regulation
        </a>
      </Button>
    </>
  );
};
